import {EntityProperty} from "./enums";

export const carsType: { [key: number]: string } = {
    [EntityProperty.None]: 'None',
    [EntityProperty.Car_Year]: 'Year',
    [EntityProperty.Car_Brand]: 'Brand',
    [EntityProperty.Car_Model]: 'Model',
    [EntityProperty.Car_Trim]: 'Trim'
};

export class SpecificAnswers {
    public value: string;
    public text: string;
    public carsType: EntityProperty;
    public carsLabel: string;
    constructor(value: any) {
        this.value = value.value.toString();
        this.text = value.text;
        this.carsLabel = carsType[this.carsType];
    }
}
